import { render, staticRenderFns } from "./UltrosundTypeTreeBicavity.vue?vue&type=template&id=1b27f298&scoped=true&"
import script from "./UltrosundTypeTreeBicavity.vue?vue&type=script&lang=js&"
export * from "./UltrosundTypeTreeBicavity.vue?vue&type=script&lang=js&"
import style0 from "./UltrosundTypeTreeBicavity.vue?vue&type=style&index=0&id=1b27f298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27f298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VTextarea})
